import React from 'react';

import { withBemMod } from '@bem-react/core';

import type { IconProps as LegoIconProps } from '../../Icon';
import { cnIcon } from '../../Icon';

import '../../Icon/_glyph/Icon_glyph.css';
interface HrIconProps {
    glyph?: 'type-indeterminate';
    sizeManagement?: 'self' | 'parent';
}

export const withGlyphTypeIndeterminate = withBemMod<HrIconProps, LegoIconProps>(
    cnIcon(),
    {
        glyph: 'type-indeterminate',
    },
    (Icon) =>
        ({ className, sizeManagement = 'self', ...props }) => {
            return (
                <Icon
                    {...props}
                    className={cnIcon({ hasGlyph: 'noFill', sizeManagement }, [className])}
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                    >
                        <path
                            d="M15 9C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11H5C4.44772 11 4 10.5523 4 10C4 9.44772 4.44772 9 5 9H15Z"
                            fill="currentColor"
                        />
                    </svg>
                </Icon>
            );
        },
);
